export default "__VITE_ASSET__DH$xIA1b__"